import { render, staticRenderFns } from "./FirstProjectButton.vue?vue&type=template&id=0945a114&"
import script from "./FirstProjectButton.vue?vue&type=script&lang=js&"
export * from "./FirstProjectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports